import { Button, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { IoMdHeart } from 'react-icons/io';
import { SECONDARY_COLOR } from '../../constants';
import hand from '../../assets/images/handIcon.png';

export function LoginMessage({ setLoginStarted }: { setLoginStarted: any }) {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    let intervals = setInterval(() => {
      setToggle((x) => !x);
    }, 1000);

    return () => {
      clearInterval(intervals);
    };
  }, []);

  return (
    <Stack gap={3} alignItems={'start'}>
      <Stack gap={1}>
        <Typography
          zIndex={10}
          gap={1}
          fontSize={25}
          variant="h4"
          display={'flex'}
          lineHeight={0.7}
          alignItems={'end'}
        >
          Welcome{' '}
          <img
            className="w-8 h-8"
            style={{
              animation: toggle ? `hands 1s infinite ease-in-out` : 'none',
            }}
            src={hand}
            alt="hand"
          />
          {/* <PiHandsPraying /> */}
        </Typography>
        <Typography fontSize={18} variant="h6" display={'flex'} alignItems={'center'} gap={0.5}>
          It's our privilege to have you{' '}
          <IoMdHeart
            color={SECONDARY_COLOR}
            style={
              {
                animation: toggle ? `heartbeat 1s infinite ease-in-out` : 'none',
              } as any
            }
            fontSize={25}
          />
        </Typography>
      </Stack>
      <Stack direction="row" gap={1}>
        <Button
          variant="contained"
          onClick={() => setLoginStarted(true)}
          size="large"
          sx={{
            borderRadius: 10,
            px: 3,
            textTransform: 'none',
            // fontWeight: '500'
          }}
        >
          <Typography fontWeight={'600'}>Sign Up</Typography>
        </Button>
        <Button
          variant="outlined"
          onClick={() => setLoginStarted(true)}
          size="large"
          sx={{
            borderRadius: 10,
            px: 3,
            textTransform: 'none',
            // fontWeight: '500'
          }}
        >
          <Typography fontWeight={'600'}>Sign In</Typography>
        </Button>
      </Stack>
    </Stack>
  );
}
